import { createSelector } from 'reselect'

const drawItSelector = state => state.drawIt

const drawItDeleteReferenceMediaSelector = createSelector(
	[ drawItSelector ],
	drawItState => ({
		icon: drawItState.icon,
	})
)

export default drawItDeleteReferenceMediaSelector
